
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import DatePicker from 'vuejs-datepicker/src/components/Datepicker.vue';
import moment from 'moment-timezone';

@Component({
  components: {
    DatePicker
  }
})
export default class DateFilter extends Vue {
  @Prop() startDate!: any;
  @Prop() endDate!: any;
  @Prop() options!: any;
  @Prop() filterName!: string;
  @Prop() disabledDate!: boolean;
  @Prop({ default: 0 }) limitDays?: number;
  @Prop() dashboard!: boolean;
  @Prop() inputName!: string;
  @Prop() input!: boolean;
  @Prop() filterName1!: string;
  @Prop() options1!: any;

  public filteredData: any = {
    startDate: this.startDate,
    endDate: this.endDate,
    selectedOne: this.options
      ? typeof this.options[0] === 'object'
        ? this.options[0].value
        : this.options[0]
      : '',
    inputText: '',
    selectedTwo: this.options1
      ? typeof this.options1[0] === 'object'
        ? this.options1[0].value
        : this.options1[0]
      : ''
  };

  public state: any = {
    startDisabledDates: {
      to: this.disabledDate
        ? new Date(
          this.currentDate.year,
          this.currentDate.month - 36,
          this.currentDate.day
        )
        : null,
      from: new Date(
        this.currentDate.year,
        this.currentDate.month,
        this.currentDate.day
      )
    },
    endDisabledDates: {
      to: this.disabledDate
        ? new Date(this.currentDate.year, this.currentDate.month, 1)
        : this.limitDays ? new Date(
          this.currentDate.year,
          this.currentDate.month,
          this.currentDate.day - 1
        ) : null,
      from: new Date(
        this.currentDate.year,
        this.currentDate.month,
        this.currentDate.day
      )
    }
  };

  updateDates() {
    if (this.filteredData.endDate && !this.limitDays) {
      this.state.startDisabledDates.from = new Date(
        moment(this.filteredData.endDate).year(),
        moment(this.filteredData.endDate).month(),
        moment(this.filteredData.endDate).date() + 1
      );
    }
    if (this.filteredData.startDate) {
      if (
        this.limitDays &&
        moment(this.filteredData.endDate).startOf('day').valueOf() >= moment(this.filteredData.startDate).add(this.limitDays, 'days').startOf('day').valueOf()
      ) {
        this.filteredData.endDate = moment(this.filteredData.startDate).add(this.limitDays - 1, 'days').format('YYYY-MM-DD');
      } else if (moment(this.filteredData.endDate).startOf('day').valueOf() < moment(this.filteredData.startDate).startOf('day').valueOf()) {
        this.filteredData.endDate = moment(this.filteredData.startDate).format('YYYY-MM-DD');
      }
      this.state.endDisabledDates.to = new Date(
        moment(this.filteredData.startDate).year(),
        moment(this.filteredData.startDate).month(),
        moment(this.filteredData.startDate).date()
      );
      if (
        this.limitDays &&
        moment().valueOf() > moment(this.filteredData.startDate).add(this.limitDays, 'days').valueOf()
      ) {
        this.state.endDisabledDates.from = new Date(
          moment(this.filteredData.startDate).year(),
          moment(this.filteredData.startDate).month(),
          moment(this.filteredData.startDate).date() + this.limitDays,
        );
      } else {
        this.state.endDisabledDates.from = new Date(
          this.currentDate.year,
          this.currentDate.month,
          this.currentDate.day
        );
      }
    }
  }

  get currentDate() {
    const now = new Date();
    return {
      year: now.getFullYear(),
      month: now.getMonth(),
      day: this.dashboard ? now.getDate() : now.getDate() + 1
    };
  }

  handleFilter() {
    this.filteredData = {
      startDate: this.filteredData.startDate
        ? moment(this.filteredData.startDate).format('YYYY-MM-DD')
        : null,
      endDate: this.filteredData.endDate
        ? moment(this.filteredData.endDate).format('YYYY-MM-DD 23:59:59')
        : null,
      selectedOne: this.options ? this.filteredData.selectedOne : '',
      inputText: this.input ? this.filteredData.inputText : '',
      selectedTwo: this.options ? this.filteredData.selectedTwo : ''
    };
    this.$emit('filtered-dates', this.filteredData);
  }

  // resets all the data
  resetFilter() {
    this.filteredData = {
      startDate: null,
      endDate: null,
      selectedOne: this.options
        ? typeof this.options[0] === 'object'
          ? this.options[0].value
          : this.options[0]
        : '',
      inputText: '',
      selectedTwo: this.options1
        ? typeof this.options1[0] === 'object'
          ? this.options1[0].value
          : this.options1[0]
        : ''
    };
    this.state.startDisabledDates.from = new Date(
      this.currentDate.year,
      this.currentDate.month,
      this.currentDate.day
    );
    this.state.endDisabledDates.to = this.disabledDate
      ? new Date(this.currentDate.year, this.currentDate.month, 1)
      : null;
    this.$emit('reset-filter', this.filteredData);
  }
}
